import { Fragment, useCallback, useEffect, useState } from "react";
import { IS_READ_ONLY_USER } from "src/utils/controllerAdapterForOfferPage";
import { TableCell } from "src/pages/OfferPage/TableSvgOrganizer/TableCell";
import { CustomCell } from "src/pages/OfferPage/TableSvgOrganizer/CustomCell";
import { RowTools } from "src/pages/OfferPage/TableSvgOrganizer/RowTools/RowTools";
import { modifyMinusRow } from "src/utils/CustomRowUtils";
import {
  useUpdateCableCustomItemMutation,
  useUpdateConventionalDevicesCustomItemMutation,
  useUpdateElectricalCustomItemMutation,
  useUpdateNhcCustomItemMutation,
  useUpdateProjectCustomItemMutation,
  useUpdateRackCabinetCustomItemMutation,
  useUpdateRoomCustomItemMutation
} from "src/api/v1/quote-ApiSlice";
import { useUpdateCustomSectionItemMutation } from "src/api/v1/section-ApiSlice";

export const CustomModifyMinusRow = (
    {
      neededCols,
      rows,
      cancelCustomRow,
      entityType,
      entityId,
      currency,
      modifyRow,
      setModifyRow,
      showTools,
      dispatchDownloadStates,
      setCurrentRowInEditing,
      measurementSystem,
    }: {
      neededCols: any;
      rows: any;
      cancelCustomRow: () => void;
      entityType: any;
      entityId: any;
      currency: string;
      modifyRow: any;
      setModifyRow: any;
      showTools: boolean;
      dispatchDownloadStates: any;
      setCurrentRowInEditing: any;
      measurementSystem: string;
    }
) => {

  const [ updateRoomCustomItem ] = useUpdateRoomCustomItemMutation();
  const [ updateProjectCustomItem ] = useUpdateProjectCustomItemMutation();
  const [ updateElectricalCustomItem ] = useUpdateElectricalCustomItemMutation();
  const [ updateNhcCustomItem ] = useUpdateNhcCustomItemMutation();
  const [ updateCustomSectionItem ] = useUpdateCustomSectionItemMutation();
  const [ updateRackCabinetCustomItem ] = useUpdateRackCabinetCustomItemMutation();
  const [ updateCableCustomItem ] = useUpdateCableCustomItemMutation();
  const [ updateConventionalDevicesCustomItem ] = useUpdateConventionalDevicesCustomItemMutation();

  const [successResponse, setSuccessResponse] = useState(null);

  const confirmCustomRow = useCallback(() => {
    if (modifyRow && entityType && entityId && currency) {
      const originalQuantity = rows.find(
          (x: any) =>
              !x.custom && x.product_id === modifyRow.product_id && x.quantity > 0
      ).quantity;

      modifyMinusRow(
          modifyRow,
          entityType,
          currency,
          originalQuantity,
          setSuccessResponse,
          updateRoomCustomItem,
          updateProjectCustomItem,
          updateElectricalCustomItem,
          updateNhcCustomItem,
          updateRackCabinetCustomItem,
          updateCableCustomItem,
          updateConventionalDevicesCustomItem,
          updateCustomSectionItem,
      );
    }
  }, [modifyRow, entityType, entityId, currency]);

  const handleChange = (event: any) => {
    const newCustomItem = Object.assign({}, modifyRow);

    setModifyRow({
      ...newCustomItem,
      [event.target.id]: event.target.value,
    });
  };

  useEffect(() => {
    if (successResponse) {
      setCurrentRowInEditing({});
    }
  }, [successResponse]);

  return !IS_READ_ONLY_USER ? (
      <Fragment>
        {neededCols.map((col: any, key: any) => (
            <TableCell
                key={key}
                width={col.data === "manufacturer_name" || col.data === "custom_description" ? "200" : "width" in col ? col.width : "auto"}
                numeric={col.numeric}
                cellCallback={col.cellCallback}
            >
              {col.data === "quantity" ? (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ marginRight: "5px" }}>-</span>
                    <CustomCell
                        isNumeric={true}
                        cellName={col.data}
                        defaultValue={Math.abs(modifyRow.quantity)}
                        handleChange={handleChange}
                        autoFocus={true}
                        confirmRow={confirmCustomRow}
                        cancelRow={cancelCustomRow}
                        customItem={modifyRow}
                    />
                  </div>
              ) : (
                  <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        height: "40px",
                        padding: "0 15px",
                        textAlign: "left",
                      }}
                  >
                    {col.render(modifyRow[col.data], modifyRow, {
                      measurementSystem: measurementSystem,
                    })}
                  </div>
              )}
              {showTools && col.data === "product_name" ? (
                  <RowTools
                      cancelCustomRow={cancelCustomRow}
                      confirmCustomRow={confirmCustomRow}
                      modifyRow={modifyRow}
                      setModifyRow={setModifyRow}
                      minusRow={true}
                  />
              ) : null}
            </TableCell>
        ))}
      </Fragment>
  ) : null;
};
